import { Component, ViewEncapsulation } from '@angular/core';
import { DBSelectOption, DBIconModule, DBMenuModule } from '@db/db-core';
import { getAppThemeName } from 'src/app/core/functions/common.function';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageMenuComponent } from '../../language-menu/language-menu.component';
import {DBHeaderLinkConfigDirective, DBHeaderModule} from '@db/db-components';

@Component({
  selector: 'app-header-db',
  templateUrl: './header-db.component.html',
  styleUrls: ['./header-db.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    DBHeaderModule,
    DBIconModule,
    DBMenuModule,
    LanguageMenuComponent,
    DBHeaderLinkConfigDirective
  ]
})
export class DbHeaderComponent {
  dbSelectOptions: DBSelectOption[] = [];
  currentLang = '';
  public width: number = window.innerWidth;

  constructor(
    private auth: AuthService
  ) {}

  get isAuthenticated$() {
    return this.auth.isAuthenticated$;
  }

  onLogout() {
    this.auth.logout();
  }

  protected readonly getAppThemeName = getAppThemeName;

  onResize(event: Event) {
    this.width = window.innerWidth;
  }
}
